<template>
  <div class="advancedVersion">
    <div class="version-box" v-show="show">
      <!-- 商品分析_商品回购分析 -->
      <div v-if="typeIndex === 0">
        <img class="bg" :src="bgUrl" alt="" />
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + uploadBtnUrl + ')  no-repeat' }"
          class="upload-btn animate"
        ></el-button>
        <!-- 功能亮点 -->
        <div class="function-wrap">
          <div class="tab-line">
            <div class="tab-wrap">
              <div
                class="tab-item"
                style="margin-right: 30px"
                @click="switchTab(0)"
                :class="{ active: tabIndex == '0' }"
              >
                <img :src="icon_tab1" alt="" />
                <span>商品回购周期分析</span>
              </div>
            </div>
            <div class="tab-wrap">
              <div
                class="tab-item"
                @click="switchTab(1)"
                :class="{ active: tabIndex == '1' }"
              >
                <img :src="icon_tab2" alt="" />
                <span>商品销售连带分析</span>
              </div>
            </div>
          </div>
          <div class="function-box">
            <img v-if="tabIndex == '0'" :src="function_1" alt="" />
            <img v-else :src="function_2" alt="" />
          </div>
        </div>
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + btnUpgradeUrl + ')  no-repeat' }"
          class="upload-btn2 animate"
        ></el-button>
      </div>
      <!-- 自动化营销pop -->
      <div v-if="typeIndex === 1">
        <img class="bg" :src="autoMarketPop" alt="" />
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + uploadBtnUrl + ')  no-repeat' }"
          class="upload-btn animate"
        ></el-button>
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + btnUpgradeUrl + ')  no-repeat' }"
          class="upload-btn2 animate"
        ></el-button>
      </div>
      <!-- 忠诚度管理 自营 pop -->
      <div v-if="typeIndex === 2 || typeIndex === 3">
        <img v-if="typeIndex === 2" class="bg" :src="loyaltySelft" alt="" />
        <img v-if="typeIndex === 3" class="bg" :src="loyaltyPop" alt="" />
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + btnLoyaltyUrl + ')  no-repeat' }"
          class="animate loyalty-upload"
        ></el-button>
        <!-- 轮播图 -->
        <div class="swiper-box">
          <div class="swiper-content" ref="swiperRef">
            <swiper
              class="swiper"
             :options="swiperOption"
            >
              <swiper-slide>
                <img :src="banner_1" />
              </swiper-slide>
              <swiper-slide>
                <img :src="banner_2" />
              </swiper-slide>
              <swiper-slide>
                <img :src="banner_3" />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <el-button
          @click="navigation"
          :style="{ background: 'url(' + btnUpgradeUrl + ')  no-repeat' }"
          class="loyalty-upload2 animate"
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      bgUrl: require("@/assets/images/heightVersion/shop/shop_bg_re.jpg"), // 商品复购
      uploadBtnUrl: require("@/assets/images/heightVersion/shop/btn.png"),
      btnLoyaltyUrl: require("@/assets/images/heightVersion/shop/btn_loyalty.png"),
      btnUpgradeUrl: require("@/assets/images/heightVersion/shop/btn_upgrade.png"),
      icon_tab1: require("@/assets/images/heightVersion/shop/icon_tab1.png"),
      icon_tab2: require("@/assets/images/heightVersion/shop/icon_tab2.png"),
      function_1: require("@/assets/images/heightVersion/shop/tab_1.png"),
      function_2: require("@/assets/images/heightVersion/shop/tab_2.png"),
      autoMarketPop: require("@/assets/images/heightVersion/shop/auto_market_pop.jpg"), // 自动化营销
      loyaltySelft: require("@/assets/images/heightVersion/shop/loyalty_selft.jpg"), // 忠诚度管理自营
      loyaltyPop: require("@/assets/images/heightVersion/shop/loyalty_pop.jpg"), // 忠诚度管理pop
      banner_1: require("@/assets/images/heightVersion/shop/banner_1.jpg"), // 忠诚度管理自营
      banner_2: require("@/assets/images/heightVersion/shop/banner_2.jpg"), // 忠诚度管理自营
      banner_3: require("@/assets/images/heightVersion/shop/banner_3.jpg"), // 忠诚度管理自营

      tabIndex: 0,
      swiperList: [],

      swiperOption: {
        loop: false,
        autoplay: {
          delay: 2000,
        },
        speed: 800,
        //  paginationHide:true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      // typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      timer: null,
      show: true,
    };
  },
  computed: {
    typeIndex() {
      // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      return this.$route.meta.typeIndex;
    },
  },
  mounted() {
    this.show = false,
    setTimeout(() => {
      this.show = true
    }, 200)
    console.log('mounted')
    if (this.typeIndex === 0) {
      this.timer = setInterval(() => {
        if (this.tabIndex === 0) {
          this.tabIndex = 1;
        } else {
          this.tabIndex = 0;
        }
      }, 2500);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    switchTab(tabIndex) {
      this.tabIndex = tabIndex;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    navigation() {
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=jjfa";
      window.open(url);
    },
  },
};
</script>

<style scoped lang="scss">
.advancedVersion {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 10px 20px 60px 20px;
  background-color: #fff;
  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}
/deep/ .el-button {
  margin-left: 0 !important;
}
/deep/.swiper-pagination {
  text-align: center;
  // padding-right: 18px;

  .swiper-pagination-bullet {
    width: 36px;
    height: 5px;
    background: #eeeeee;
    border-radius: 0;
    opacity: 1;
    border-radius: 20px;
  }
  .swiper-pagination-bullet .swiper-pagination-bullet-active {
    background: #ff353e;
    width: 24px;
    opacity: 1;
  }
}
.version-box {
  width: 1000px;
  margin: 0 auto;
  position: relative;
  .swiper-box {
    position: absolute;
    width: 100%;
    top: 3450px;
    .swiper-content {
      box-sizing: border-box;
      text-align: center;
      /deep/.swiper-container {
        padding-bottom: 40px;
      }
      .swiper {
        // border-radius: 6px;
      }
    }
  }

  .function-wrap {
    position: absolute;
    width: 100%;
    top: 593px;
    .tab-line {
      text-align: center;
      .tab-wrap {
        display: inline-block;
        .tab-item {
          font-size: 16px;
          width: 250px;
          height: 79px;
          cursor: pointer;
          text-align: center;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            margin-right: 12px;
          }
          &:first-child {
            // margin-right: 30px;
          }
          &:hover,
          &.active {
            box-shadow: 0px 4px 20px 0px rgba(35, 0, 137, 0.1);
            border-radius: 8px;
          }
        }
      }
    }
    .function-box {
      text-align: center;
    }
  }

  img.bg {
    width: 1000px;
  }
  .upload-btn {
    position: absolute;
    left: 55px;
    top: 247px;
    width: 218px;
    height: 62px;
    border: none;
  }
  .upload-btn2 {
    position: absolute;
    left: 372px;
    bottom: 147px;
    width: 261px;
    height: 98px;
    border: none;
  }
  .loyalty-upload {
    position: absolute;
    left: 355px;
    top: 1134px;
    width: 291px;
    height: 95px;
    border: none;
  }
  .loyalty-upload2 {
    position: absolute;
    left: 372px;
    bottom: 100px;
    width: 261px;
    height: 98px;
    border: none;
  }
}
.animate {
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-name: breathe;
  -webkit-animation-duration: 500ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
}
@-webkit-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-moz-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-o-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>